import { render, staticRenderFns } from "./MainParkings.vue?vue&type=template&id=3c2dad51&"
import script from "./MainParkings.vue?vue&type=script&lang=js&"
export * from "./MainParkings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports